import {Component, Input, OnChanges} from '@angular/core';
import {ArticleMetricInterface} from '../../../interfaces/articles/article-metric.interface';
import {IconType} from '../fe-icon/fe-icon.component';

interface MetricItem {
  label: string;
  value: string;
}

/**
 * Données chiffrées (métriques) d'un article, sous forme d'une ligne de pastilles (même style que les leads prédictifs).
 * - liste des résultats : icône en tête, limitée à maxVisible puis « +n » avec infobulle ;
 * - modale article : ligne de tags « Données chiffrées » (showIcon=false, maxVisible=0 pour tout afficher, large).
 * La valeur affichée est celle formatée par l'API (formattedValue) ; rien n'est affiché sans métrique.
 */
@Component({
  selector: 'fe-article-metrics',
  templateUrl: './fe-article-metrics.component.html',
  styleUrls: ['./fe-article-metrics.component.scss']
})
export class FeArticleMetricsComponent implements OnChanges {

  protected readonly IconType = IconType;

  // Type « Recrutement » du référentiel "Shared".articles_metrics_type
  private static readonly TYPE_RECRUTEMENT = 3;

  @Input() metrics: Array<ArticleMetricInterface>;
  @Input() maxVisible = 3;
  @Input() showIcon = true;
  @Input() large = false;

  public items: Array<MetricItem> = [];
  public visibleItems: Array<MetricItem> = [];
  public hiddenCount = 0;
  public hiddenTooltip = '';

  ngOnChanges(): void {
    this.items = (this.metrics || [])
      .filter(metric => metric && metric.formattedValue)
      .map(metric => ({
        // Recrutement : libellé du type (« Recrutement ») plutôt que du qualificatif (« Poste »)
        label: (metric.typeId === FeArticleMetricsComponent.TYPE_RECRUTEMENT ? metric.typeName : metric.qualifierName)
          || metric.qualifierName || metric.typeName || '',
        value: metric.formattedValue
      }));
    const limit = this.maxVisible > 0 ? this.maxVisible : this.items.length;
    this.visibleItems = this.items.slice(0, limit);
    const hidden = this.items.slice(limit);
    this.hiddenCount = hidden.length;
    this.hiddenTooltip = hidden.map(item => item.label + ' : ' + item.value).join('\n');
  }
}
